const DashboardSharing = Object.freeze({
  GLOBAL: 'GLOBAL',
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
})
export default DashboardSharing
// RESERVE BELOW
